import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import * as GA from 'react-ga';

import Slider from 'react-slick';

import {
	Card,
	Icon,
	Grid,
	Divider,
	Segment,
	Button,
	Container,
	Header,
	Image
} from 'semantic-ui-react';

import { EmailCapture } from '../EmailCapture';

import './GridCaster.css';

export class GridCaster extends Component 
{
	handleBetaAccess() 
	{
		GA.event({
			category: 'early_access',
			action: 'clicked_early_access',
			label: 'click from grid caster page'
		});

		$(document.body).animate({
			scrollTop: $('#beta-access').offset().top - 20
		}, 500);
	}

	renderDescription() {
		return (
			<div>
				<Header size='huge' textAlign='left'>
					Grid Caster: Broken Kingdom
				</Header>
				<Grid stackable reversed='mobile'>
					<Grid.Column computer={10} tablet={8}>
						<p>Tired of matching things? Bored with clash and war? Grid Caster: Broken Kingdom is a new type of game that’s easy to play yet full of delightful depth to challenge your creativity. Unleash the power of shapes and colors to save a once magnificent land from a wicked force that has corrupted the Kingdom’s creatures.</p>

						<p>Your goal in each level is to free the creatures ensnared by a corrupt force that has plunged the Kingdom into darkness. In your arsenal are mystical cards etched with colored shapes. These cards have the power to reverse the corruption when cast upon infected creatures. Corrupted creatures are dangerous and will attack so use your mystical cards wisely.</p>

						<p>You are the last hope to restore peace and save the inhabitants of this once harmonious Kingdom!</p>
					</Grid.Column>
					<Grid.Column verticalAlign='middle' computer={6} tablet={8}>
						<Image centered src='../grid_caster_bk_logo.png' size='large' />
					</Grid.Column>
				</Grid>
			</div>
		);
	}

	renderTipsAndTricks() {
		return (
			<div>
			<Divider />

			<center>
				<Header size='large'>10 Tips and Tricks to Help You Get Started!</Header>
			</center>

			<Divider hidden />

			<Grid stackable columns={4}>
				<Grid.Column computer={3} mobile={1} tablet={1}>
				</Grid.Column>
				<Grid.Column computer={2} tablet={4}>
					<center>
						<a href='../ebooks/grid_caster_10_tips_ebook.pdf' target='_blank'>
							<Image src='../ebooks/gc_10_tips_promo_image.png' size='small' verticalAlign='middle' />
						</a>
					</center>
				</Grid.Column>
				<Grid.Column computer={8} tablet={10} mobile={8}>
					<p>Get this free ebook to help you get started. You'll learn 10 tips and tricks to help you along the way.</p>

					<p>You will be a pro in no time with this short and easy to read ebook!</p>

					<p>
						<a href='../ebooks/grid_caster_10_tips_ebook.pdf' target='_blank'>
							Click here to download the 10 Tips and Tricks ebook!
						</a>
					</p>
				</Grid.Column>
				<Grid.Column computer={3} mobile={1} tablet={1}>
				</Grid.Column>
			</Grid>

			<Divider />
			</div>
		);
	}

	renderEarlyRelease() {
		return (
			<div>
				<Header size='medium'>Early Release</Header>

				<p>Grid Caster: Broken Kingdom is an early release game that’s perfect for players looking for new experiences and interested in influencing the direction of a game before its official release. Gameplay and features will evolve based on your feedback so join now to experience a game like you’ve never played before!</p>
			</div>
		);
	}

	renderStoreLinks() {
		return (
			<div>
				<center>
					<Image.Group size='medium'>
						<Image 
							src='../buttons/appstores/apple.png'
							href='https://itunes.apple.com/us/app/grid-caster-broken-kingdom/id1248051696?ls=1&mt=8' 
						/>
						<Image 
							src='../buttons/appstores/google.png' 
							href='https://play.google.com/store/apps/details?id=games.captivate.polygon' 
						/>
						<Image 
							src='../buttons/appstores/amazon.png' 
							href='https://www.amazon.com/Captivate-Games-Grid-Caster-Kingdom/dp/B075VJ4SHJ/ref=sr_1_1?s=mobile-apps&ie=UTF8&qid=1516742921&sr=1-1' 
						/>
					</Image.Group>
				</center>
			</div>
		);
	}

	renderScreenshots() {
		const settings = {
			dots: true,
			infinite: true,
			speed: 1000,
			arrows: false,
			autoplaySpeed: 5000,
			slidesToShow: 2,
			slidesToScroll: 2,
			autoplay: true,
			swipeToSlide: true,
			responsive: [
				{ 
					breakpoint: 900, 
					settings: { 
						slidesToShow: 1 ,
						slidesToScroll: 1
					} 
				}, 
				{ 
					breakpoint: 1400, 
					settings: { 
						slidesToShow: 2,
						slidesToScroll: 2
					} 
				}
			]
		};
		const size = 'large';
		return (
			<div>
				<Slider ref={c => this.slider = c} {...settings}>
					<div>
						<Image centered src='../gcbk/screenshots/screenshot1.png' size={size} />
					</div>
					<div>
						<Image centered src='../gcbk/screenshots/screenshot2.png' size={size} />
					</div>
					<div>
						<Image centered src='../gcbk/screenshots/screenshot3.png' size={size} />
					</div>
					<div>
						<Image centered src='../gcbk/screenshots/screenshot4.png' size={size} />
					</div>
					<div>
						<Image centered src='../gcbk/screenshots/screenshot5.png' size={size} />
					</div>
					<div>
						<Image centered src='../gcbk/screenshots/screenshot6.png' size={size} />
					</div>
					<div>
						<Image centered src='../gcbk/screenshots/screenshot7.png' size={size} />
					</div>
				</Slider>
				<Button 
					icon='arrow left' 
					floated='left'
					onClick={(e, d) => this.slider.slickPrev()}
				/>
				<Button 
					icon='arrow right' 
					floated='right'
					onClick={(e, d) => this.slider.slickNext()}
				/>
				<Divider hidden />
				<Divider hidden />
			</div>
		);
	}

	renderTeam() {
		return (
			<div>
				<Header size='large'>Team</Header>
				<Card.Group doubling itemsPerRow={3}>
					<Card>
						<Image src='../profiles/daehan_profile.jpg' centered size='large' />
						<Card.Content>
							<Card.Header>Daehan Stevenson</Card.Header>
							<Card.Meta>Art Director</Card.Meta>
							<Card.Description>
								<a href='https://www.linkedin.com/in/daehanstevenson/'>
									<Icon name='linkedin square' size='large' />
								</a>
							</Card.Description>
						</Card.Content>
					</Card>
					<Card>
						<Image src='../profiles/steve_profile.jpg' centered size='large' />
						<Card.Content>
							<Card.Header>Steve Woodzell</Card.Header>
							<Card.Meta>Artist and Audio</Card.Meta>
							<Card.Description>
								<a href='https://www.linkedin.com/in/steve-woodzell-bab6a53/'>
									<Icon name='linkedin square' size='large' />
								</a>
							</Card.Description>
						</Card.Content>
					</Card>
					<Card>
						<Image src='../profiles/anthony_profile.jpg' centered size='large' />
						<Card.Content>
							<Card.Header>Anthony M. Russo</Card.Header>
							<Card.Meta>Artist</Card.Meta>
							<Card.Description>
								<a href='https://twitter.com/anthonymrusso'>
									<Icon name='twitter' size='large' />
								</a>
							</Card.Description>
						</Card.Content>
					</Card>
					<Card>
						<Image src='../profiles/mike_profile.jpg' centered size='large' />
						<Card.Content>
							<Card.Header>Mike Dwyer</Card.Header>
							<Card.Meta>Level Design and Engineering</Card.Meta>
							<Card.Description>
								<a href='https://www.linkedin.com/in/michaelgdwyer/'>
									<Icon name='linkedin square' size='large' />
								</a>
								<a href='https://github.com/dumaike'>
									<Icon name='github' size='large' />
								</a>
							</Card.Description>
						</Card.Content>
					</Card>
					<Card>
						<Image src='../profiles/tommy_profile.jpg' centered size='large' />
						<Card.Content>
							<Card.Header>Tommy Leung</Card.Header>
							<Card.Meta>Engineering</Card.Meta>
							<Card.Description>
								<a href='https://www.linkedin.com/in/supertommy/'>
									<Icon name='linkedin square' size='large' />
								</a>
								<a href='https://github.com/supertommy'>
									<Icon name='github' size='large' />
								</a>
								<a href='https://twitter.com/iamSuperTommy'>
									<Icon name='twitter' size='large' />
								</a>
							</Card.Description>
						</Card.Content>
					</Card>
				</Card.Group>
			</div>
		);
	}

	render() {
		return (
			<div>
				<div className='gc-header ui vertical masthead'>
					<div className='ui center aligned text container'>
					</div>
				</div>
				<Grid>
					<Grid.Row>
						<Grid.Column width={16}>
							<Divider hidden />
							<Container>
								<Segment basic size='large'>

									{this.renderDescription()}

									<Divider hidden />

									{this.renderStoreLinks()}

									<Divider hidden />

									{this.renderScreenshots()}

									<Divider hidden />

									{this.renderEarlyRelease()}

									{this.renderTipsAndTricks()}

									<Divider hidden />

									{this.renderTeam()}
								</Segment>
							</Container>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column width={16}>
							<EmailCapture />
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/GridCaster/GridCaster.js